module.exports = __webpack_public_path__ + "img/6_UTARTU.88f01af7.jpg";